import { useState } from "react";
import { CreditCard, Landmark, Smartphone, QrCode, Apple, Wallet } from "lucide-react";

export const PAY_METHODS = [
  { v: "all", label: "Any method", icon: Wallet },
  { v: "card", label: "Card", icon: CreditCard },
  { v: "eft", label: "Instant EFT", icon: Landmark },
  { v: "capitec_pay", label: "Capitec Pay", icon: Smartphone },
  { v: "qr", label: "Scan to Pay (QR)", icon: QrCode },
  { v: "apple_pay", label: "Apple Pay", icon: Apple },
];

export const getPayChannel = () => localStorage.getItem("yva_pay_channel") || "all";

export function PayMethods({ className = "" }) {
  const [sel, setSel] = useState(getPayChannel());
  const pick = (v) => { localStorage.setItem("yva_pay_channel", v); setSel(v); };
  return (
    <div className={`text-left ${className}`} data-testid="pay-methods">
      <p className="text-xs font-semibold text-[#0B2447] mb-2">Choose how you want to pay</p>
      <div className="flex flex-wrap gap-2">
        {PAY_METHODS.map(({ v, label, icon: Icon }) => (
          <button key={v} type="button" onClick={() => pick(v)} data-testid={`pay-method-${v}`}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${sel === v ? "border-[#0B2447] bg-[#0B2447] text-white" : "border-slate-200 text-[#0B2447] hover:border-[#0B2447]/50"}`}>
            <Icon className="w-3.5 h-3.5" /> {label}
          </button>
        ))}
      </div>
    </div>
  );
}
